import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { DatePipe, NgIf } from '@angular/common';
import { UiArticleGridItem } from '@madeinlune/massaud-types';
import { MediaImageComponent } from '@nx-massaud/media/ui/image';
import { GetEntityPipe } from '@madeinlune/massaud-json-api-bridge';
import { LetDirective, PushPipe } from '@ngrx/component';
import { RouterStaticLinkDirective } from '@nx-massaud/routing/link';
import { TranslocoService } from '@ngneat/transloco';
import { CoverComponent } from '@nx-massaud/detail/ui/cover';

@Component({
  selector: 'msd-det-ui-promoted-news',
  standalone: true,
  imports: [
    MediaImageComponent,
    GetEntityPipe,
    PushPipe,
    LetDirective,
    NgIf,
    DatePipe,
    RouterStaticLinkDirective,
    CoverComponent,
  ],
  template: `
    <ng-container *ngIf="news">
      <a [routerStaticLink]="news.path">
        <msd-det-ui-cover class="cover" [media]="news.media"></msd-det-ui-cover>
        <div class="b-infos-group">
          <ng-container *ngIf="news.date">
            <span
              [innerHTML]="
                news.date | date : 'd MMMM y' : '' : (lang$ | ngrxPush)
              "
            ></span>
          </ng-container>
          <h2 [innerHTML]="news.title"></h2>
        </div>
      </a>
    </ng-container>
  `,
  styleUrls: ['./promoted-news.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class PromotedNewsComponent {
  protected translocoService = inject(TranslocoService);
  readonly lang$ = this.translocoService.langChanges$;

  @Input() news: UiArticleGridItem | undefined;
}
